import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import notFound404 from "assets/images/404.svg";
import { setIsLoading } from "core/store/slices/settingSlice";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setIsLoading(false));
  }, [dispatch]);

  return (
    <div className="mx-auto flex w-full max-w-mxWidth min-h-[calc(100dvh-240px)] mmd:min-h-[calc(100dvh-260px)] lap:min-h-[calc(100dvh-280px)] flex-col items-center justify-center px-25 py-40 mmd:py-60 lap:py-80 overflow-y-auto">
      <main className="flex flex-col items-center text-center">
        <img
          src={notFound404}
          alt="404"
          className="h-auto w-[180px] mmd:w-[220px] lap:w-[244px] shrink-0"
        />

        <div className="mt-24 lap:mt-40 h-[3px] w-[44px] bg-black shrink-0" />

        <h1 className="mt-24 lap:mt-30 text-20 mmd:text-24 font-semibold text-black shrink-0">
          This page took a wrong turn.
        </h1>

        <p className="mt-16 max-w-[610px] text-16 mmd:text-17 text-boulder leading-normal shrink-0">
          We couldn&apos;t find the page you were looking for. It may have been moved, renamed, or is temporarily unavailable.
        </p>

        <button
          type="button"
          data-testid="not-found-go-home-button"
          className="mt-32 shrink-0 inline-flex items-center justify-center rounded-5 bg-dodgerBlue px-26 py-15 text-14 font-semibold text-white hover:bg-[#1F6FE0] min-h-[48px]"
          onClick={() => navigate("/")}
        >
          Go to Homepage
        </button>
      </main>
    </div>
  );
};

export default NotFoundPage;
